export default __webpack_public_path__ + "img/fAehyNSm.7cee7eef.svg";